import { notification, Button } from 'ant-design-vue'
import {
  // CloseOutlined,
  CheckCircleFilled,
  ExclamationCircleFilled,
  CloseCircleFilled
} from '@ant-design/icons-vue'
import { CloseOutlined } from '@/components/icon/index'
import CloseIcon from '@/pages/okr/pages/user/components/rightContent/Modal/components/CloseIcon.vue'
import { h, ref } from 'vue'
import './notice.less'
notification.config({
  maxCount: 1
})
// import { modalButtonStyle as style } from './../constants/index'
const style = {
  'padding-left': '2px',
  'padding-right': '2px',
  minWidth: '80px',
  height: '32px',
  'border-radius': '4px'
}
const classMap = {
  success: 'success',
  error: 'error',
  warn: 'confim',
  confim: 'confim'
}
const iconMap = {
  success: CheckCircleFilled,
  error: CloseCircleFilled,
  warn: ExclamationCircleFilled,
  confim: ExclamationCircleFilled
}
const CONFIM = 'confim'
function useNotice({
  message = '',
  description = '',
  type = CONFIM,
  btn = ['取消', '确认'],
  isCenter = true,
  onOk = () => {},
  onCancel = () => {},
  ...props
} = {}) {
  const key = `open${Date.now()}`
  notification.open({
    closeIcon: CloseOutlined,
    placement: 'topLeft',
    key,
    style: 'left:0%',
    class: `log-test-notice ${classMap[type]} ${ description ? 'has-description' : ''}`,
    duration: type == CONFIM ? null : 1,
    onClose() {
      onCancel()
      clearStyle()
    },
    btn:
      type == CONFIM &&
      btn &&
      (() => {
        let isLoading = ref(false)
        let buttons = []
        let cancelText = '',
          onText = ''
        if (btn.length == 1) {
          cancelText = ''
          onText = btn[0]
        } else if (btn.length == 2) {
          cancelText = btn[0]
          onText = btn[1]
        }
        const CancelINS = h(
          Button,
          {
            style,
            onClick: () => {
              onCancel()
            }
          },
          cancelText
        )
        const OnINS = h(
          Button,
          {
            loading: false,
            onClick: () => {
              OnINS.component.props.loading = true
              onOk(() => {
                OnINS.component.props.loading = false
              })
            },
            style: { ...style, 'margin-left': '12px', 'padding-left': '3px' },
            type: 'primary'
          },
          onText
        )
        if (btn.length == 1) {
          buttons = [OnINS]
        } else if (btn.length == 2) {
          buttons = [CancelINS, OnINS]
        }
        return h(
          'div',
          {
            class: 'log-button-wrapper'
          },
          buttons
        )
      })(),
    message: h('div', [h(iconMap[type], { class: `log-notice-icon-wrapper ${type}` }), message]),
    description,
    ...props
  })
  let NotificaWrapper = null
  try {
    if (isCenter) {
      setTimeout(() => {
        let noticeDom = document.querySelector('.log-test-notice')
        if (noticeDom) {
          let parentDom = noticeDom.parentElement.parentElement
          if (parentDom) {
            parentDom.style = 'top:50%;left:50%;transform: translate(-50%, -50%);'
            let wrapper = parentDom.parentElement
            NotificaWrapper = wrapper
            if (wrapper) {
              wrapper.style =
                'width: 100%;height: 100%;position: fixed;top: 0;left: 0;z-index: 999999;background:rgba(0,0,0,0.5)'
            }
          }
        }
      })
    }
  } catch (error) {
    console.log(error)
  }
  function clearStyle() {
    if (NotificaWrapper) {
      NotificaWrapper.style = ''
    }
  }
  return function () {
    clearStyle()
    notification.close(key)
  }
}
export { useNotice }
